export default {
  id: {
    value: null,
    required: false,
    state: null
  },
  numeroProcesso: {
    value: null,
    required: true,
    state: null
  },
  instancia: {
    value: null,
    required: false,
    state: null,
    options: [
      { value: 1, text: '1ª Instância' },
      { value: 2, text: '2ª Instância' },
      { value: 3, text: '3ª Instância' },
      { value: 4, text: '4ª Instância' }
    ]
  },
  pessoaId: {
    value: null,
    required: false,
    options: [],
    state: null
  },
  assuntoId: {
    value: null,
    required: true,
    options: [],
    state: null
  },
  objetoAcaoId: {
    value: null,
    required: true,
    options: [],
    state: null
  },
  comarcaId: {
    value: null,
    required: true,
    state: null
  },
  prognosticoId: {
    value: null,
    required: true,
    state: null
  },
  faseId: {
    value: null,
    required: true,
    options: [],
    state: null
  },
  advogadoResponsavelId: {
    value: null,
    required: true,
    options: [],
    state: null
  },
  advogadoContrarioId: {
    value: null,
    required: false,
    options: [],
    state: null
  },
  valorCausa: {
    value: null,
    required: true,
    state: null
  },
  valorCausa2: {
    value: null,
    required: false,
    state: null
  },
  dataDistribuicao: {
    value: null,
    required: true,
    state: null
  },
  ultimoAndamento: {
    value: null,
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/details/ajuizamento/modal/ajuizamentomodal-form.js